/// <amd-module name="VSSUI/Components/Icon/Icon" />
import * as React from "react";
import { Tooltip } from "VSSUI/TooltipEx";
import { css, getSafeId } from "VSSUI/Util";
import { IIconProps } from "./Icon.Props";

export function Icon(props: Readonly<IIconProps>): JSX.Element {
    if (props.render) {
        return props.render(props.className);
    }

    const iconWrapperProps: React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> = {
        id: getSafeId(props.id),
        onClick: props.onClick,
        onMouseDown: props.onMouseDown,
        onKeyDown: props.onKeyDown,
        role: props.role ? props.role : props.ariaLabel || props.ariaLabelledBy ? "img" : undefined,
        style: props.style,
        tabIndex: props.tabIndex,
        title: props.title
    };

    const iconClassName = css(
        props.className,
        "flex-noshrink",
        props.iconName && "fabric-icon",
        props.iconName && `ms-Icon--${props.iconName}`,
        props.size
    );

    const ariaHidden = props.ariaHidden == "removed" ? undefined : props.ariaHidden !== undefined ? props.ariaHidden : "true";

    let icon =
        props.ariaLabel || props.ariaLabelledBy || props.ariaExpanded !== undefined ? (
            <span
                aria-expanded={props.ariaExpanded}
                aria-label={props.ariaLabel}
                aria-labelledby={getSafeId(props.ariaLabelledBy)}
                className={css("fluent-icons-enabled", props.wrapperClass)}
                {...iconWrapperProps}
            >
                <span aria-hidden={ariaHidden} className={iconClassName} />
            </span>
        ) : (
            <span className="fluent-icons-enabled">
                <span aria-hidden={ariaHidden} className={iconClassName} {...iconWrapperProps} />
            </span>
        );

    if (props.tooltipProps) {
        icon = <Tooltip {...props.tooltipProps}>{icon}</Tooltip>;
    }

    return icon;
}
